/**
 * Migration 0095 — count of booking requests awaiting approval, for the nav
 * badge on the Today entry. Polls on mount + every 60s; fails soft (0) when
 * the caller lacks `bookings.approve` or the request errors.
 */
import { useEffect, useState } from 'react';
import { countBookingRequests } from './booking_requests_api';

const POLL_MS = 60_000;

export function useBookingRequestCount(enabled = true): number {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return;
    }
    let cancelled = false;
    async function load() {
      try {
        const res = await countBookingRequests();
        if (!cancelled) setCount(res.count);
      } catch {
        if (!cancelled) setCount(0);
      }
    }
    void load();
    const id = setInterval(() => void load(), POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [enabled]);

  return count;
}
